export default __webpack_public_path__ + "static/media/hht2_direction_eggstudio_02.d5688e73.png";